import ContentLoader from 'react-content-loader';
import type { VoidFunctionComponent } from 'react';

import Flex from '../../../generic/Flex';
import Checkbox from '../../../generic/Forms/Checkbox';

type Props = {
  shouldHideCheckbox?: boolean;
};

/**
 * Represents a single loading row for the issues table.
 * Note that this isn't a React component and should not be "called",
 * instead just render it directly.
 */
const IssueItemLoading: VoidFunctionComponent<Props> = ({ shouldHideCheckbox }) => (
  <div className="issue-loading-row">
    {!shouldHideCheckbox && (
      <Flex align="flex-start">
        <Checkbox
          isChecked={false}
          isDisabled
          isRippleDisabled
        />
      </Flex>
    )}
    <Flex grow="1" align="flex-start">
      <ContentLoader
        width="100%"
        height="48px"
      >
        <rect x="0" y="0" rx="4" ry="4" width="90%" height="24" />
        <rect x="0" y="32" rx="4" ry="4" width="70%" height="16" />
      </ContentLoader>
    </Flex>
  </div>
);

export default IssueItemLoading;
